<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="上次金额">
                  <el-input  v-model="queryForm.lastMoney"></el-input>
              </el-form-item>
              <el-form-item label="本次金额">
                  <el-input  v-model="queryForm.currentMoney"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopSubsidyRecordList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addShopSubsidyRecord"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editShopSubsidyRecord(null)"-->
<!--        >修改</el-button>-->
<!--        <el-button-->
<!--          type="danger"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-delete"-->
<!--          :disabled="multipleSelection.length <= 0"-->
<!--          @click="deleteShopSubsidyRecord(null)"-->
<!--        >删除</el-button>-->
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>

        
        <span title="导出数据" class="icon-box" @click="exportShopSubsidyRecordList">
            <Icon color="#606266">
                <ArrowDownload24Regular />
            </Icon>
        </span>

<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->

        <span
          class="icon-box"
          @click="refreshShopSubsidyRecordList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopSubsidyRecordList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="lastMoney"
        label="上次金额"
        min-width="150"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="currentMoney"
        label="本次金额"
        min-width="150"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        min-width="150"
      > </el-table-column>
<!--      <el-table-column-->
<!--        fixed="right"-->
<!--        align="center"-->
<!--        label="操作"-->
<!--        width="300"-->
<!--      >-->
<!--        <template slot-scope="scop">-->
<!--          <div class="operation">-->
<!--            <div @click="checkShopSubsidyRecord(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Eye24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">查看</span>-->
<!--            </div>-->
<!--            <div @click="editShopSubsidyRecord(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
<!--            <div @click="deleteShopSubsidyRecord(scop.row.id)">-->
<!--              <Icon size="16" style="color: red">-->
<!--                <Delete24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label" style="color: red">删除</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopSubsidyRecordStates[shopSubsidyRecordState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopSubsidyRecord"
          ref="shopSubsidyRecordForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="日期"
            prop="dayDate"
          >
            <el-input
              size="small"
              v-model="shopSubsidyRecord.dayDate"
              :disabled="shopSubsidyRecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="上次基数"
            prop="lastMoney"
          >
            <el-input
              size="small"
              v-model="shopSubsidyRecord.lastMoney"
              :disabled="shopSubsidyRecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="增长比率"
            prop="currentRatio"
          >
            <el-input
              size="small"
              v-model="shopSubsidyRecord.currentRatio"
              :disabled="shopSubsidyRecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="本次金额"
            prop="currentMoney"
          >
            <el-input
              size="small"
              v-model="shopSubsidyRecord.currentMoney"
              :disabled="shopSubsidyRecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="本次累计补贴金额"
            prop="totalMoney"
          >
            <el-input
              size="small"
              v-model="shopSubsidyRecord.totalMoney"
              :disabled="shopSubsidyRecordState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopSubsidyRecordState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopSubsidyRecordList();
                    this.getShopSubsidyRecordList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopSubsidyRecordList();
                    this.getShopSubsidyRecordList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     dayDate: '', //日期
                     lastMoney: '', //上次基数
                     currentRatio: '', //增长比率
                     currentMoney: '', //本次金额
                     totalMoney: '', //本次累计补贴金额
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopSubsidyRecordState: 'add',
                shopSubsidyRecordStates: {
                    add: '新建补贴记录',
                    check: '查看补贴记录',
                    edit: '修改补贴记录'
                },

                multipleSelection: [],
                shopSubsidyRecordList: [],
                shopSubsidyRecord: {
                    id: '', //
                    dayDate: '', //日期
                    lastMoney: '', //上次基数
                    currentRatio: '', //增长比率
                    currentMoney: '', //本次金额
                    totalMoney: '', //本次累计补贴金额
                },
                btnLoading: false,

                rules: {
                    dayDate: [{ required: true, message: '日期不能为空', trigger: 'blur' }],
                    lastMoney: [{ required: true, message: '上次基数不能为空', trigger: 'blur' }],
                    currentRatio: [{ required: true, message: '增长比率不能为空', trigger: 'blur' }],
                    currentMoney: [{ required: true, message: '本次金额不能为空', trigger: 'blur' }],
                    totalMoney: [{ required: true, message: '本次累计补贴金额不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getShopSubsidyRecordList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetShopSubsidyRecordList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopSubsidyRecordList = [];
            },
            resetDialog() {
                this.shopSubsidyRecordState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      dayDate: '', //日期
                      lastMoney: '', //上次基数
                      currentRatio: '', //增长比率
                      currentMoney: '', //本次金额
                      totalMoney: '', //本次累计补贴金额
                };
                this.getShopSubsidyRecordList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopSubsidyRecord = {
                      id: '', //
                      dayDate: '', //日期
                      lastMoney: '', //上次基数
                      currentRatio: '', //增长比率
                      currentMoney: '', //本次金额
                      totalMoney: '', //本次累计补贴金额
                };
            },
            submitForm() {
                if (this.shopSubsidyRecordState == 'add') {
                    this.$refs.shopSubsidyRecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/subsidyrecord/add`,{ ...this.shopSubsidyRecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopSubsidyRecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopSubsidyRecordState == 'edit') {
                    this.$refs.shopSubsidyRecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/subsidyrecord/edit`,{ ...this.shopSubsidyRecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopSubsidyRecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopSubsidyRecord() {
                this.showDialog = true;
                this.shopSubsidyRecordState = 'add';
            },
            checkShopSubsidyRecord(shopSubsidyRecordId) {
                console.log(shopSubsidyRecordId);
                this.currentShopSubsidyRecordId = shopSubsidyRecordId;

                this.getShopSubsidyRecordById();
                this.showDialog = true;
                this.shopSubsidyRecordState = 'check';
            },
            editShopSubsidyRecord(shopSubsidyRecordId) {
                console.log('shopSubsidyRecord', shopSubsidyRecordId);
                if (shopSubsidyRecordId) {
                    this.currentShopSubsidyRecordId = shopSubsidyRecordId;
                    this.getShopSubsidyRecordById();
                } else {
                    this.shopSubsidyRecord = { ...this.shopSubsidyRecord, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopSubsidyRecordState = 'edit';
            },
            deleteShopSubsidyRecord(shopSubsidyRecordId) {
                let ids = '';
                if (shopSubsidyRecordId) {
                    ids = shopSubsidyRecordId;
                } else {
                    ids = this.multipleSelection.map((shopSubsidyRecord) => shopSubsidyRecord.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/subsidyrecord/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopSubsidyRecordList();
                                this.getShopSubsidyRecordList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopSubsidyRecordList() {
                this.resetShopSubsidyRecordList();
                this.getShopSubsidyRecordList();
            },
            getShopSubsidyRecordList(query = {}) {
                this.loading = true;
                get(`/shop/subsidyrecord/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopSubsidyRecordList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopSubsidyRecordById() {
                get(`/shop/subsidyrecord/get`,{ id: this.currentShopSubsidyRecordId }).then((res) =>{
                    if(res.success){
                      this.shopSubsidyRecord = { ...this.shopSubsidyRecord, ...res.shopSubsidyRecord };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopSubsidyRecordList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/subsidyrecord/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/subsidyrecord/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/subsidyrecord/importData`,formData);
              this.refreshShopSubsidyRecordList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopSubsidyRecordList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopSubsidyRecordList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>